module.exports = __webpack_public_path__ + "img/Marca14.e147bb7f.jpg";